import React, { useEffect, useRef, useState } from "react";
import "./Grid.css";

export default function PalmFeatures() {
  const sectionRef = useRef(null);
  const [view, setView] = useState("default");

  useEffect(() => {
    const target = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          target.classList.add("animate-in");
        } else {
          target.classList.remove("animate-in");
        }
      },
      { threshold: 0.2 }
    );

    if (target) observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      id="palm-features"
      className="Grid-background"
      style={{
        backgroundImage: "url('/background.png')",
        backgroundSize: "contain",
        backgroundRepeat: "repeat",
        backgroundPosition: "center",
        color: "white",
      }}
    >
      <div className="features-wrapper" ref={sectionRef}>
        {/* Heading */}
        <div className="text-wrapper">
          <h1 className="heading">Innovation That Starts with Your Palm</h1>
          <p className="subheading">
            Reimagining identity verification with contactless palm vein
            technology: ultra-secure, hygienic, and lightning-fast.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="cta-buttons">
          <button
            className={`btn-secondary ${view === "b2b" ? "active" : ""}`}
            onClick={() => setView("b2b")}
          >
            B2B
          </button>
          <button
            className={`btn-secondary ${view === "b2b2c" ? "active" : ""}`}
            onClick={() => setView("b2b2c")}
          >
            B2B2C
          </button>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {view === "default" && (
            <>
              <img
                src="https://res.cloudinary.com/dlurlrbou/image/upload/v1753724400/img_r6vntd.png"
                alt="Access Control"
                className="feature-box"
              />
              <img
                src="https://res.cloudinary.com/dlurlrbou/image/upload/v1753724401/Img1_haztwu.png"
                alt="Enterprise Security"
                className="feature-box"
              />
              <img
                src="https://res.cloudinary.com/dywlcf7kr/image/upload/v1751886226/Screenshot_2025-05-29_202524_se2hdh.png"
                alt="Identity Verification"
                className="feature-box"
              />
              <img
                src="https://res.cloudinary.com/dlurlrbou/image/upload/v1753724405/img3_qfe0zf.png"
                alt="Multi-factor Security"
                className="feature-box"
              />
            </>
          )}

          {view === "b2b" && (
            <>
              <img src="/img.png" alt="B2B Feature 1" className="feature-box" />
              <img
                src="https://res.cloudinary.com/dlurlrbou/image/upload/v1753724401/Img1_haztwu.png"
                alt="Enterprise Security"
                className="feature-box"
              />
              <img src="/img2.png" alt="B2B Feature 3" className="feature-box" />
              <img src="/img3.png" alt="B2B Feature 4" className="feature-box" />
            </>
          )}

          {view === "b2b2c" && (
            <>
              <img
                src="/b2b2c2.png"
                alt="B2B2C Feature 1"
                className="feature-box"
              />
              <img
                src="/b2c2c1.png"
                alt="B2B2C Feature 2"
                className="feature-box"
              />
              <img
                src="/b2b2c3.png"
                alt="B2B2C Feature 3"
                className="feature-box"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
